import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { SuggestionBox } from './SuggestionBox';

export function SuggestionBoxButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Button - Bottom LEFT instead of right */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 left-6 bg-gradient-to-r from-amber-500 to-orange-500 text-white p-4 rounded-full shadow-lg hover:shadow-xl hover:shadow-amber-500/50 transition-all z-[9997] group"
        title="Send us a suggestion"
      >
        <MessageSquare className="w-6 h-6" />
        <span className="absolute left-full ml-3 bg-slate-900 text-white px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Send Suggestion
        </span>
      </button>

      {/* Suggestion Box Modal */}
      <SuggestionBox isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
